const music = [
  { label: "Various genres of music", value: "Various genres of music" },
  { label: "Nasheed with music", value: "Nasheed with music" },
  { label: "Nasheed without music", value: "Nasheed without music" },
  { label: "No music", value: "No music" },
  { label: "No music - only Quran", value: "No music - only Quran" },
];
export default music;
